import React, { useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import FemtyzHome from "./pages/FemtyzHome";
import Settings from "./pages/Settings";
import SearchResults from "./pages/SearchResults";
import ProductDetail from "./pages/ProductDetail";
import Subscription from "./pages/Subscription";
import ContactUs from "./pages/ContactUs";
import TermsAndConditions from "./pages/TermsAndConditions";
import FAQ from "./pages/FAQ";
import AuthOverlay from "./components/auth/AuthOverlay";
import ForgotPasswordOverlay from "./components/auth/ForgotPasswordOverlay";
import MobileMenuDrawer from "./components/MobileMenuDrawer";
import { logout } from "./store/auth/authSlice";

function AppShell() {
  const [auth, setAuth] = useState({ open: false, mode: "login" });
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const isLoggedIn = Boolean(token);

  function handleOpenAuth(mode) {
    setAuth({ open: true, mode: mode || "login" });
  }

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <FemtyzHome
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
        <Route
          path="/settings"
          element={
            <Settings
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
        <Route
          path="/search"
          element={
            <SearchResults
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
        <Route
          path="/product/:id"
          element={
            <ProductDetail
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
        <Route
          path="/subscription"
          element={
            <Subscription
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
        <Route
          path="/contact"
          element={
            <ContactUs
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
        <Route
          path="/terms"
          element={
            <TermsAndConditions
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
        <Route
          path="/faq"
          element={
            <FAQ
              onOpenAuth={handleOpenAuth}
              onOpenMenu={() => setMenuOpen(true)}
            />
          }
        />
      </Routes>

      <AuthOverlay
        open={auth.open}
        initialMode={auth.mode}
        onClose={() => setAuth((s) => ({ ...s, open: false }))}
        onLoginSuccess={() => {
          setAuth((s) => ({ ...s, open: false }));
          navigate("/settings");
        }}
        onOpenForgotPassword={() => {
          setAuth((s) => ({ ...s, open: false }));
          setForgotPasswordOpen(true);
        }}
      />
      <ForgotPasswordOverlay
        open={forgotPasswordOpen}
        onClose={() => setForgotPasswordOpen(false)}
        onOpenLogin={() => {
          setForgotPasswordOpen(false);
          handleOpenAuth("login");
        }}
      />
      <MobileMenuDrawer
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        onOpenAuth={handleOpenAuth}
        isLoggedIn={isLoggedIn}
        onLogout={() => {
          dispatch(logout());
          setMenuOpen(false);
          navigate("/");
        }}
        onSelectMenuItem={(key) => {
          if (key === "home") navigate("/");
          if (key === "profile") {
            navigate("/settings");
          }
          if (key === "subscription") navigate("/subscription");
          if (key === "contact") navigate("/contact");
          if (key === "terms & conditions") navigate("/terms");
          if (key === "faq") navigate("/faq");
        }}
      />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
